import React, { useState } from "react";
import "./Common_History_Expert.css";
import Common_Rate_Btn from "../common-rate-btn/Common_Rate_Btn";
import History_Expert_Rate_Btn_Modal from "../../header/history/history-expert/history-expert-rate-btn-modal/History_Expert_Rate_Btn_Modal";
import { IDS } from "../../../utils/IDS";

const Common_History_Expert = ({ data }) => {
  const [showRateModal, setShowRateModal] = useState(false);
  const [selectedExpert, setSelectedExpert] = useState(null);

  if (!data) return null;

  const handleOpenModal = () => {
    setSelectedExpert(data);
    setShowRateModal(true);
  };
  const handleCloseModal = () => {
    setShowRateModal(false);
    setSelectedExpert(null);
  };

  const calculateAge = (dob) => {
    if (!dob) return "-";

    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // adjust if birthday not yet reached this year
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  return (
    <div className="history-expert-card">
      <div className="history-expert-header-bar">
        Details ID: {data?.id || "#ORD00000"}
      </div>

      <div className="history-expert-content">
        <div className="history-expert-thumb">
          {/* <img
            src={`${IDS.IMG_URL}/${data?.expert?.profile_pic}`}
            alt={data.name}
            className="expert-img"
          /> */}
          <img
            src={
              data?.expert?.profile_pic
                ? `${IDS.IMG_URL}/${data?.expert?.profile_pic}`
                : "/assets/images/expert2.png"
            }
            alt={data?.expert?.name}
            className="expert-img"
            onError={(e) => {
              e.target.src = "/assets/images/expert2.png";
            }}
          />
        </div>
        <div className="history-expert-body">
          <div className="history-info-row">
            <span className="info-label">Name:</span>
            <span className="info-value">{data?.expert?.name}</span>
          </div>
          <div className="history-info-row">
            <span className="info-label">Field:</span>
            <span className="info-value">{data?.profession?.name}</span>
          </div>
          <div className="history-info-row">
            <span className="info-label">Sub Field:</span>
            <span className="info-value">
              {data?.profession?.expertsubprofession?.length
                ? data.profession.expertsubprofession
                    .map((item) => item.name)
                    .join(", ")
                : "-"}
            </span>
          </div>
          <div className="history-info-row">
            <span className="info-label">Experience:</span>
            <span className="info-value">
              {data?.expert?.user_details?.experience}
            </span>
          </div>

          <div className="history-info-row">
            <span className="info-label">Age:</span>
            <span className="info-value">
              {calculateAge(data?.expert?.user_details?.dob)} yrs
            </span>
          </div>
        </div>
      </div>

      {data?.rate_us ? (
        <div className="rated-message">⭐ You rated: {data.rate_us}</div>
      ) : (
        <Common_Rate_Btn onBtnClick={handleOpenModal} />
      )}
      <History_Expert_Rate_Btn_Modal
        show={showRateModal}
        handleClose={handleCloseModal}
        modalId={selectedExpert?.id}
        modalType="expert"
        modalName={selectedExpert?.expert?.name}
        modalField={selectedExpert?.profession?.name}
        modalAge={selectedExpert?.age}
        modalExperience={selectedExpert?.experience}
        modalImg={
          selectedExpert?.expert?.profile_pic
            ? `${IDS.IMG_URL}/${selectedExpert?.expert?.profile_pic}`
            : "/assets/images/expert2.png"
        }
      />
    </div>
  );
};

export default Common_History_Expert;
